export default {
  data() {
    return {
      alturaTela: window.innerHeight,
      posicaoTopTabela: 0,
    };
  },
  computed: {
    altura() {
      return this.alturaTela - 180 - this.posicaoTopTabela;
    },
  },
  methods: {
    onResize(tabela, recarregar) {
      const tabelas = document.getElementsByClassName(tabela);
      if (tabelas && tabelas.length && (!this.posicaoTopTabela || recarregar)) {
        this.posicaoTopTabela = tabelas[0].getBoundingClientRect().top;
      }
      this.alturaTela = window.innerHeight;
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/apuracao/alturaTabelaMixin.js